import { useEffect, useState } from 'react';
import { StationStatusSocket } from '@/ws/station';
import type { StationDetailOut } from '@/api/stations';

/**
 * Conecta no /ws/stations/{id} e mantém o `StationDetailOut` atualizado
 * em tempo real. O servidor envia um snapshot inicial assim que abre, e
 * push de update a cada `STATION_STATUS_CHANGED` do Hub. Reconnect com
 * backoff exponencial via `StationStatusSocket`.
 *
 * Retorna `null` enquanto não recebeu o primeiro snapshot — caller pode
 * mostrar skeleton.
 */
export function useStationSocket(stationId: string | null): StationDetailOut | null {
  const [station, setStation] = useState<StationDetailOut | null>(null);

  useEffect(() => {
    if (!stationId) return;
    setStation(null);
    const socket = new StationStatusSocket(stationId);
    const unsubscribe = socket.subscribe((evt) => {
      if (evt.event === 'snapshot' || evt.event === 'station_changed') {
        setStation(evt.station);
      }
      // ping é só keep-alive — ignora
    });
    socket.connect();
    return () => {
      unsubscribe();
      socket.close();
    };
  }, [stationId]);

  return station;
}
